import { gql } from "@apollo/client"

// graphQL query to send contact us form data
export const SUBMIT_FORM = gql`
  mutation EmailEnquiry($input: inquiryInput) {
    emailEnquiry(input: $input)
  }
`
